import React from 'react';
import { ArrowDropDown } from '@mui/icons-material';
import { slideFromTop } from '@/components/features/casino/crash/GameBox/PreviourRoundResult/styles';
import { getStaticAsset } from '@/utils/staticAsset';
import Image from 'next/image';

interface UserDropdownTriggerProps {
  iconColor: string;
  isOpen: boolean;
  onClick: () => void;
  anchorRef?: React.RefObject<HTMLDivElement>;
}

const UserDropdownTrigger: React.FC<UserDropdownTriggerProps> = ({
  iconColor,
  isOpen,
  onClick,
  anchorRef,
}) => {
  return (
    <div
      className="flex items-center h-[38px] w-fit px-2 cursor-pointer border-2 border-white/15 pr-0 rounded-xl"
      style={{
        animation: `${slideFromTop} 0.5s ease-in-out`,
      }}
      onClick={onClick}
      ref={anchorRef}
    >
      <Image
        src={getStaticAsset('/assets/images/logo/profile-logo.png')}
        alt="Profile"
        width={24}
        height={24}
        className="rounded-full"
      />
      <ArrowDropDown
        sx={{
          fontSize: '24px',
          marginLeft: '-4px',
          color: iconColor,
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
      />
    </div>
  );
};

export default UserDropdownTrigger; 